---
title: About Me
coverImage: https://picsum.photos/200
date: 2023-09-26T02:32:00.000Z
excerpt: a summary of my experience, skills, and knowledge
hidden: true
tags:
---

```json:about_me.json
Jack: Software Engineer = {
  years of experience: 4,
  platforms: [web, microservice clusters, federated],
  applications: [ML operations, data engineering, network security],
  domain knowledge: [live_streaming, port & behavior based host id],
  technical scope: [design & review, code, devops],
  leadership skills: [requirements spec, scoping, mentoring, process optimization]
}
```
